import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../../utils/createRoutes';
import type { SessionDurationBreakdown, TimelineTopicItem } from '../../types/topicQuiz';
import { formatDurationMinutes } from '../../types/topicQuiz';
import {
  plannerTopicsToCurriculumTopics,
  saveCurriculumPathForTimeline,
} from '../../utils/curriculumPathStorage';
import { savePlannerTopics } from '../../utils/topicPlannerStorage';

interface SessionBannerProps {
  label: string;
  title: string;
  batch: string;
  studentCount: number;
  duration: SessionDurationBreakdown;
  /** Current planner topics — saved before Add Topic so Prepare keeps them. */
  topics?: TimelineTopicItem[];
}

export function SessionBanner({
  label,
  title,
  batch,
  studentCount,
  duration,
  topics = [],
}: SessionBannerProps) {
  const navigate = useNavigate();

  const handleAddTopic = () => {
    // Persist planner state so Curriculum Builder can restore topics + times.
    savePlannerTopics(topics);
    saveCurriculumPathForTimeline(plannerTopicsToCurriculumTopics(topics));
    navigate(ROUTES.prepareSession, {
      state: { continueFromPlanner: true },
    });
  };

  return (
    <div className="card mb-3">
      <div className="card-body py-3">
        <div className="d-flex flex-wrap justify-content-between align-items-start gap-3">
          <div>
            <div className="text-muted small text-uppercase">{label}</div>
            <h5 className="mb-1">{title}</h5>
            <p className="mb-1 small text-muted">
              Batch: {batch} · {studentCount} Students Enrolled
            </p>
            <p className="mb-0 small">
              Session: <strong>{formatDurationMinutes(duration.totalMinutes)}</strong>
              <span className="text-muted">
                {' '}
                ({formatDurationMinutes(duration.topicMinutes)} topics
                {duration.quizMinutes > 0 &&
                  ` + ${formatDurationMinutes(duration.quizMinutes)} quizzes`}
                )
              </span>
            </p>
          </div>
          <div className="d-flex flex-wrap gap-2">
            <button
              type="button"
              className="btn btn-outline-secondary btn-sm"
              onClick={handleAddTopic}
            >
              Add Topic
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
